import * as React from "react";
import styled, { css } from "../../../styled/index";
import { BaseInputCSS } from "../input/index";
import { ArrowDownIcon } from "./icon";
const SelectComponent = styled("select") `
  ${BaseInputCSS};
  option {
    padding: 5px 0;
    /* &:checked{
        background-color: lighten(0.15, #FB2F2F);
      } */
    &:disabled {
      background-color: darken(white, 15%);
    }
  }
  ${(props) => props.version === 'v2' ? css `
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    border: 1px solid #dfdfdf;
    border-radius: 2px;
    margin-right: 2rem;
    padding: 0.5rem;
    padding-right: 2rem;
  ` : css ``};
  
`;
const SelectWrapper = styled("div") `
    position: relative;
    width: 100%;
`;
export const Select = (props) => (React.createElement(SelectWrapper, null,
    React.createElement(SelectComponent, { ...props },
        props.placeholder && React.createElement("option", { value: "" }, props.placeholder || ""),
        props.options.map((o, i) => {
            return (React.createElement("option", { key: i, value: o.value, disabled: o.disabled || false }, o.label));
        })),
    props.version === 'v2' && React.createElement(ArrowDownIcon, null)));
//# sourceMappingURL=index.js.map